// extracted by mini-css-extract-plugin
export default {"main-util__wrapper":"main-util_main-util__wrapper__5HjBl","main-util__icon":"main-util_main-util__icon__rR6bn","main-util__title":"main-util_main-util__title__-AYSO"};